import * as Yup from "yup";

const validationSchema = Yup.object({
    templateName: Yup.string()
        .required("Template Name is required.").max(100, "Maximum limit is 100")
});

export { validationSchema };
